import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const login = (email, password) => {
    const storedUsers = JSON.parse(localStorage.getItem("users")) || [];
    const foundUser = storedUsers.find(
      u => u.email === email && u.password === password
    );

    if (foundUser) {
      setUser(foundUser);
      localStorage.setItem("user", JSON.stringify(foundUser));
      return true;
    }
    return false;
  };

  const register = (name, email, password) => {
    const storedUsers = JSON.parse(localStorage.getItem("users")) || [];
    const newUser = { name, email, password };
    localStorage.setItem("users", JSON.stringify([...storedUsers, newUser]));
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("user");
  };

  return (
    // ✅ ON AJOUTE setUser ICI POUR QU'IL SOIT ACCESSIBLE DANS Profile.jsx
    <AuthContext.Provider value={{ user, setUser, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}